import { t } from 'localization'

const TP = 'productTemplate.utils.under-retail-utils'

export const MINIMUM_DISCOUNT_PERCENTAGE_TO_DISPLAY_UNDER_RETAIL = 5

export const getDiscountPercentage = (retailPriceCents: number, lowestPriceCents: number) => {
  if (retailPriceCents <= 0 || lowestPriceCents <= 0) {
    return null
  }

  const discount = retailPriceCents - lowestPriceCents
  const discountPercentage = (discount / retailPriceCents) * 100

  return Number(discountPercentage.toFixed(0))
}

export const getUnderRetailLabel = (
  experimentVariant: string,
  discountPercentage: number,
  country: string,
) => {
  if (
    discountPercentage > MINIMUM_DISCOUNT_PERCENTAGE_TO_DISPLAY_UNDER_RETAIL &&
    country === 'US'
  ) {
    switch (experimentVariant) {
      case 'variant1':
        return t(`${TP}.underRetailLabelVariant1`, 'Under Retail Price')
      case 'variant2':
        return t(`${TP}.underRetailLabelVariant2`, {
          defaultValue: '{discountPercentage}% under retail',
          discountPercentage: discountPercentage,
        })
      default:
        return ''
    }
  }

  return ''
}
